<template>
  <div class="stadyList">
    <el-table :data="tableData.rows" style="width: 100%" max-height="250">
      <el-table-column prop="date" label="封面">
        <template slot-scope="scope">
          <img :src="wjSrc+scope.row.img" style="width: 52px;height: 31px;border-radius: 3px;" />
        </template>
      </el-table-column>
      <el-table-column prop="cname" label="名称">
      </el-table-column>
      <el-table-column prop="ks" label="课时">
      </el-table-column>
      <el-table-column prop="createTime" label="学习时间">
      </el-table-column>
      <el-table-column prop="studyTime" label="学习时长">
      </el-table-column>

      <el-table-column prop="learnstate" label="进度" width="295">
        <template slot-scope="scope">
          <div class="learnstateDiv">
            <div class="progressL">
              <div :style="'width:'+scope.row.percent+'%'"></div>
            </div>
            <div class="disFlex between">
              <div></div>
              <div>学习总时长：{{scope.row.allTime}}分钟</div>
              <div>{{scope.row.percent}}%</div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    name: 'StadyList',
    props: ['creator', 'wjSrc'],
    data() {
      return {
        formInline: {
        },
        tableData: {
          rows: [],
          total: 0
        },
        options: [],
        tjData: {}
      }
    },
    methods: {
      getList: function(id) {
        this.$axios.get('/kt/ktProductAppy/getlearnlistall.htm?' + this.$qs.stringify(this.formInline)).then(res => {
          var data = res.data;
          this.tableData = {
            rows:data,
            total:data.length
          };
        })
      },
      getTjdata: function() {
        this.$axios.get('/kt/learnfile/getLearntime.htm?creator=' + this.creator).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.tjData = data.data;
          } else {
            // this.$message.error(data.message);
          }
        })
      }
    },
    created: function() {
      this.formInline={
        productid:this.$route.query.id,
        creator:this.$route.query.creator
      };
    },
    mounted: function() {},
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList();
        },
        deep: true //true 深度监听
      },
      creator: {
        handler(val, oldVal) {
          this.$set(this.formInline, 'creator', val);
          this.getTjdata(); //统计数据
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .stadyBlok {
    height: 118px;
    opacity: 1;
    margin-right: 20px;
    background: #00bc68;
    border-radius: 4px;
  }

  .kuaiStady {
    background-color: #fff;
    height: 107px;
    margin-top: 11px;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    padding: 0 20px;
  }

  .stadyName {
    height: 22px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
  }

  .stadyNum {
    height: 38px;
    opacity: 1;
    font-size: 30px;
    font-family: 'HelveticaNeue';
    text-align: left;
    color: rgba(0, 0, 0, 0.85);
    line-height: 38px;
  }

  .stadyList .el-table th {
    background-color: #EFEFEF;
  }

  .learnstateDiv {
    width: 284px;
  }

  .progressL {
    width: 284px;
    height: 6px;
    opacity: 1;
    background: #f5f5f5;
    border-radius: 8px;
    margin-bottom: 11px;
  }

  .progressL div {
    height: 6px;
    opacity: 1;
    background: #0071ba;
    border-radius: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/stadyList.vue